export enum SimulationTaskStatus {
	CREATED = 'CREATED',
	IN_PROGRESS = 'IN_PROGRESS',
	ERROR = 'ERROR',
	NOT_FULFILLED = 'NOT_FULFILLED',
	FULFILLED = 'FULFILLED',
}
